import React from 'react';
export default function UploadFile(_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "1em", height: "1em", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960" },
        React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M452-202h60v-201l82 82 42-42-156-152-154 154 42 42 84-84zM160-80v-800h421l219 219v581zm391-554v-186H220v680h520v-494zM220-820v186zv680z" })));
}
